<template>
    <div>
        <b-button
            @click="$bvModal.show(modalId)"
            variant="default"
            title="Login"
            v-if="params.data.is_active"
            class="mr-1"
        >
            <font-awesome-icon :icon="['fas', 'user']" />
        </b-button>
        <b-button
            @click="$bvModal.show(modalIdMobile)"
            title="App Login As..."
            variant="default"
            v-if="params.data.is_active"
             class="mr-1"
        >
            <font-awesome-icon :icon="['fas', 'mobile-screen-button']" />
        </b-button>
        <b-button variant="default" :href="editUserLink">
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <modal
            :id="modalId"
            title="Login as user
            
"
            @ok="logInAsUser"
        >
            Are you sure you want to log in as {{ params.data.email }}?
        </modal>
        <modal
            :id="modalIdMobile"
            title="Login as user on the mobile app"
            @ok="logInAsUserMobile"
        >
            Are you sure you want to log in as {{ params.data.email }} on the mobile app?
        </modal>
    </div>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';
export default {
    components: {
        Modal,
    },
    computed: {
        modalId() {
            return 'sign-as' + this.params.data.id;
        },
        modalIdMobile() {
            return 'sign-as-mobile-' + this.params.data.id;
        },
        editUserLink() {
            return `/app/admin/user/details/${this.params.data.id}`;
        },
    },
    methods: {
        logInAsUser() {
            this.params.logInAsUser &&
                this.params.logInAsUser(this.params.data.id);
        },
        logInAsUserMobile() {
            window.location = `/administrative/login_as_user/${this.params.data.id}?redirect_to_mobile_app=true`;
        },
    },
};
</script>

<style>
</style>